import React from 'react';
import { LaGraphSearch } from './LaGraphSearch';
import { LaDownloadMenu } from './LaDownloadMenu';

export const LaGraphToolbar = () => {
  return (
    <div id="linkAnalysisGraphToolbar">
      <LaGraphSearch />
      <LaDownloadMenu />
    </div>
  );
};
